import { render } from "./CashEndorsement.vue?vue&type=template&id=9e04124e"
import script from "./CashEndorsement.vue?vue&type=script&lang=js"
export * from "./CashEndorsement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__